import { getAPIPath } from '@interhyp/platform-request';
import fetchWrapper, { getConnection } from '@interhyp/util-request';

const transformResponse = ({ fname, lname, ...rest }: { fname: string; lname: string }) => ({
  firstName: fname,
  lastName: lname,
  ...rest,
});

export const getProfileData = async (): Promise<unknown> => {
  try {
    const res = await fetchWrapper(
      getConnection(),
      `${getAPIPath('advisory-excellence-portal')}/home/api/customers/profile/v1/me`,
    );
    // check response
    if (res.status === 200) {
      return transformResponse(await res.json());
    }
    return null;
  } catch {
    //
    return null;
  }
};
